/* ============================================================
   YELASAI Hair Active Light — interactions
   ============================================================ */
(function () {
  "use strict";

  /* ---------- Header scroll state ---------- */
  var header = document.getElementById("site-header");
  function onScroll() {
    if (window.scrollY > 24) header.classList.add("scrolled");
    else header.classList.remove("scrolled");
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("in"); });
  }

  /* ---------- ROI calculator ---------- */
  var WEEKS = 48;
  var elClients = document.getElementById("in-clients");
  var elPrice = document.getElementById("in-price");
  var elDays = document.getElementById("in-days");

  function fmt(n) { return Math.round(n).toLocaleString("de-DE"); }

  function setText(id, val) {
    var n = document.getElementById(id);
    if (n) n.textContent = val;
  }

  function animateNumber(id, target, isCurrency) {
    var node = document.getElementById(id);
    if (!node) return;
    var start = parseFloat((node.dataset.cur || "0")) || 0;
    var t0 = performance.now();
    var dur = 520;
    function step(now) {
      var p = Math.min(1, (now - t0) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      var v = start + (target - start) * eased;
      node.textContent = fmt(v);
      if (p < 1) requestAnimationFrame(step);
      else { node.textContent = fmt(target); node.dataset.cur = target; }
    }
    node.dataset.cur = start;
    requestAnimationFrame(step);
  }

  function calcROI() {
    var clients = +elClients.value;
    var price = +elPrice.value;
    var days = +elDays.value;

    var perWeekCount = clients * days;
    var week = perWeekCount * price;
    var month = week * 4;
    var year = week * WEEKS;
    var sessions = perWeekCount * WEEKS;
    // Beispielinvestition ~ 18.000 € (Orientierung) -> Amortisation in Monaten
    var invest = 18000;
    var amort = Math.max(1, Math.round(invest / Math.max(1, month)));

    setText("r-clients", clients);
    setText("r-price", price);
    setText("r-days", days);
    setText("r-week-count", perWeekCount);

    animateNumber("r-year", year);
    animateNumber("r-week", week);
    animateNumber("r-month", month);
    setText("r-sessions", fmt(sessions));
    setText("r-amort", amort);
  }

  [elClients, elPrice, elDays].forEach(function (el) {
    if (el) el.addEventListener("input", calcROI);
  });
  // seed dataset for smooth first animation
  ["r-year", "r-week", "r-month"].forEach(function (id) {
    var n = document.getElementById(id);
    if (n) n.dataset.cur = (n.textContent || "0").replace(/\./g, "");
  });

  /* ---------- 33 Gründe accordion ---------- */
  var cats = document.querySelectorAll("[data-cat]");
  cats.forEach(function (cat) {
    var head = cat.querySelector(".cat-head");
    head.addEventListener("click", function () {
      var isOpen = cat.classList.contains("open");
      cats.forEach(function (c) {
        c.classList.remove("open");
        var h = c.querySelector(".cat-head");
        if (h) h.setAttribute("aria-expanded", "false");
      });
      if (!isOpen) {
        cat.classList.add("open");
        head.setAttribute("aria-expanded", "true");
      }
    });
  });

  /* ---------- Before / After slider ---------- */
  var stage = document.getElementById("ba");
  if (stage) {
    var afterLayer = document.getElementById("ba-after-layer");
    var handle = document.getElementById("ba-handle");
    var dragging = false;

    function setSplit(clientX) {
      var rect = stage.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(4, Math.min(96, pct));
      afterLayer.style.setProperty("--split", pct + "%");
      handle.style.left = pct + "%";
    }
    afterLayer.style.setProperty("--split", "50%");

    function startDrag(e) { dragging = true; e.preventDefault(); }
    function moveDrag(e) {
      if (!dragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setSplit(x);
    }
    function endDrag() { dragging = false; }

    handle.addEventListener("mousedown", startDrag);
    handle.addEventListener("touchstart", startDrag, { passive: false });
    window.addEventListener("mousemove", moveDrag);
    window.addEventListener("touchmove", moveDrag, { passive: false });
    window.addEventListener("mouseup", endDrag);
    window.addEventListener("touchend", endDrag);
    // click-to-position on the stage
    stage.addEventListener("click", function (e) {
      if (e.target.closest(".ba-handle")) return;
      setSplit(e.clientX);
    });
  }

  /* ---------- Lead form ---------- */
  var form = document.getElementById("lead-form");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var ok = true;
      ["f-name", "f-salon", "f-email"].forEach(function (id) {
        var f = document.getElementById(id);
        if (!f.value.trim()) { f.style.borderColor = "var(--spec-r)"; ok = false; }
        else { f.style.borderColor = ""; }
      });
      var email = document.getElementById("f-email");
      if (email.value && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value)) {
        email.style.borderColor = "var(--spec-r)"; ok = false;
      }
      if (!ok) return;
      form.style.display = "none";
      document.getElementById("form-success").classList.add("show");
    });
  }

  /* ---------- Video autoplay nudge ---------- */
  var vids = document.querySelectorAll("video");
  function tryPlay() { vids.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }); }
  tryPlay();
  window.addEventListener("pointerdown", tryPlay, { once: true });
  if ("IntersectionObserver" in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); } });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { vio.observe(v); });
  }

  /* ---------- Smooth anchor offset for fixed header ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener("click", function (e) {
      var id = a.getAttribute("href");
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var y = target.getBoundingClientRect().top + window.scrollY - 64;
      window.scrollTo({ top: y, behavior: "smooth" });
    });
  });

  /* ---------- Lite YouTube: inline play on click (no leaving the page) ---------- */
  document.querySelectorAll(".yt-lite").forEach(function (b) {
    b.addEventListener("click", function () {
      var id = b.getAttribute("data-yt");
      var start = b.getAttribute("data-start");
      var ifr = document.createElement("iframe");
      ifr.src = "https://www.youtube-nocookie.com/embed/" + id + "?autoplay=1&rel=0" + (start ? "&start=" + start : "");
      ifr.title = b.getAttribute("aria-label") || "YouTube";
      ifr.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share");
      ifr.setAttribute("allowfullscreen", "");
      ifr.style.cssText = "position:absolute;inset:0;width:100%;height:100%;border:0;display:block";
      b.replaceWith(ifr);
    });
  });
})();
